module.exports = __webpack_public_path__ + "img/stickers_0005_eggplant.4272779d.png";